import { render, staticRenderFns } from "./cv-page.vue?vue&type=template&id=48e14b1a&"
import script from "./cv-page.vue?vue&type=script&lang=js&"
export * from "./cv-page.vue?vue&type=script&lang=js&"
import style0 from "./cv-page.vue?vue&type=style&index=0&id=48e14b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports